import TrainingSessionLesson from '../session-lesson';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingSessionLesson.destroy(({ trainingId, sessionId, lessonId }, fetch) => {
    return fetch.delete(`/trainings/${trainingId}/sessions/${sessionId}/lessons/${lessonId}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };